import { render, staticRenderFns } from "./ReferralDataTab.vue?vue&type=template&id=2a52e095&scoped=true"
import script from "./ReferralDataTab.vue?vue&type=script&lang=js"
export * from "./ReferralDataTab.vue?vue&type=script&lang=js"
import style0 from "./ReferralDataTab.vue?vue&type=style&index=0&id=2a52e095&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2a52e095",
  null
  
)

export default component.exports